(function () {
  var GRAPH_SELECTOR = '[data-products-second-graph]';

  function initGraph(root) {
    var graph = root.querySelector(GRAPH_SELECTOR);
    if (!graph || graph.dataset.graphAnimated === 'true') return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      graph.classList.add('is-animated');
      graph.dataset.graphAnimated = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          graph.classList.add('is-animated');
          graph.dataset.graphAnimated = 'true';
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(graph);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-products-second]').forEach(initGraph);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
